// extracted by mini-css-extract-plugin
export default {"contactButton":"contactButton_contactButton__lLICf","Shimiring":"contactButton_Shimiring__f4q55"};